import {
  FaHome, FaBriefcase, FaUserTie, FaRobot, FaEnvelope,
  FaTshirt, FaDumbbell, FaFireAlt, FaWifi,
  FaReact, FaMobileAlt, FaDatabase,
  FaLinkedin, FaGithub, FaDownload, FaCertificate,
  FaBars, FaTimes, FaChevronLeft, FaChevronRight,
  FaArrowRight, FaPlay, FaPause, FaRedo,
  FaArrowUp, FaArrowDown, FaGripVertical,
  FaPalette, FaFont, FaImage, FaSave, FaUndo,
  FaFileExport, FaFileImport, FaEdit,
} from 'react-icons/fa';
import { SiTypescript, SiFirebase, SiExpo } from 'react-icons/si';

const iconRegistry = {
  FaHome, FaBriefcase, FaUserTie, FaRobot, FaEnvelope,
  FaTshirt, FaDumbbell, FaFireAlt, FaWifi,
  FaReact, FaMobileAlt, FaDatabase,
  FaLinkedin, FaGithub, FaDownload, FaCertificate,
  FaBars, FaTimes, FaChevronLeft, FaChevronRight,
  FaArrowRight, FaPlay, FaPause, FaRedo,
  FaArrowUp, FaArrowDown, FaGripVertical,
  FaPalette, FaFont, FaImage, FaSave, FaUndo,
  FaFileExport, FaFileImport, FaEdit,
  SiTypescript, SiFirebase, SiExpo,
};

export function getIcon(name) {
  return iconRegistry[name] || null;
}
